import { COLORS, ASSETS } from "../styles/tokens";
import { useViewport } from "../hooks";

interface FooterProps {
  onNavigateToOnboard?: () => void;
}

export function Footer({ onNavigateToOnboard }: FooterProps) {
  const { isMobile } = useViewport();
  return (
    <footer
      className="layer glass"
      style={{
        padding: isMobile ? "32px 16px 100px" : "48px 32px",
        borderTop: `1px solid ${COLORS.border}`,
        position: "relative",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 20,
          alignItems: isMobile ? "flex-start" : "center",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img src={ASSETS.badge} alt="" style={{ width: 32, height: 32, opacity: 0.8 }} />
          <div>
            <div className="mono" style={{ fontSize: 11, color: COLORS.inkDim, letterSpacing: "0.1em", marginBottom: 2 }}>
              LEANBACK DIGITAL
            </div>
            <div className="mono" style={{ fontSize: 10, color: COLORS.inkMute, letterSpacing: "0.1em" }}>
              © 2026 · REALSYNQ™
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: isMobile ? 16 : 24,
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={onNavigateToOnboard}
            className="mono"
            style={{ fontSize: 11, color: COLORS.inkDim, letterSpacing: "0.1em", textDecoration: "none", background: "transparent", border: "none", padding: 0, cursor: "pointer" }}
          >
            DOCUMENTATION
          </button>
          {[
            { label: "Privacy",     href: "https://leanback.digital/privacy-policy/" },
            { label: "Contact",     href: "https://leanback.digital/contact" },
          ].map(({ label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="mono"
              style={{ fontSize: 11, color: COLORS.inkDim, letterSpacing: "0.1em", textDecoration: "none" }}
            >
              {label.toUpperCase()}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
